// api/template.ts
import axiosAuthInstance from '../utils/getSubdomain';
import {
  HierarchyTopicGroup,
  HierarchyTopicSelection,
} from '../types/hierarchyTopic';

export interface Question {
  complexity: 'easy' | 'medium' | 'hard';
  number: number;
}

export type TopicWithQuestions = HierarchyTopicSelection;
export type TopicGroup = HierarchyTopicGroup;

export interface Template {
  _id: string;
  name: string;
  thumbnail?: string;
  subject: string;
  status: 'draft' | 'published';
  topic_groups: TopicGroup[];
  selected_subjects: number[];
  created_at: string;
}

export const createTemplate = (data: {
  name: string;
  subject: string;
  groups: any[];
  thumbnail?: File | null;
  status: string;
  grade: string;
}) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('subject', data.subject.toString());
  formData.append('groups_json', JSON.stringify(data.groups));
  formData.append('status', data.status);
  formData.append('grade', data.grade);
  if (data.thumbnail) {
    formData.append('thumbnail', data.thumbnail);
  }

  return axiosAuthInstance.post('/templates/', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};

export const getTemplates = (params?: {
  status?: string;
  subject?: string;
  start_date?: string;
  end_date?: string;
  limit?: number;
  offset?: number;
}) => {
  return axiosAuthInstance.get<Template[]>('/templates/', { params });
};

export const publishTemplate = (templateId: string) => {
  return axiosAuthInstance.put(`/templates/${templateId}/publish`);
};

export const getTemplateById = (templateId: string) => {
  return axiosAuthInstance.get<Template>(`/template/${templateId}`);
};

export const editTemplate = (
  templateId: string,
  data: {
    name: string;
    subject: string;
    groups: any[];
    thumbnail?: File | null;
  }
) => {
  const formData = new FormData();
  formData.append('name', data.name);
  formData.append('subject', data.subject.toString());
  formData.append('groups_json', JSON.stringify(data.groups));
  if (data.thumbnail instanceof File) {
    formData.append('thumbnail', data.thumbnail);
  }

  return axiosAuthInstance.patch(`/templates/${templateId}`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
};
